import initSentry from "./config/sentry.config";

initSentry("client");
